export default __webpack_public_path__ + "static/media/logo2.05e33548.png";